import { render, staticRenderFns } from "./inputUpload.vue?vue&type=template&id=28b4ea59"
import script from "./inputUpload.vue?vue&type=script&lang=js"
export * from "./inputUpload.vue?vue&type=script&lang=js"
import style0 from "./inputUpload.vue?vue&type=style&index=0&id=28b4ea59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports